import React from "react";
import Hero from "../sections/hero/Hero";

function Homepage() {
  return (
    <div>
      <Hero />
    </div>
  );
}

export default Homepage;
